module.exports = __webpack_public_path__ + "img/yy.88de8ef6.png";